import { render, staticRenderFns } from "./LProjectConfigurationMailingOptions.vue?vue&type=template&id=573b40b0&"
import script from "./LProjectConfigurationMailingOptions.vue?vue&type=script&lang=js&"
export * from "./LProjectConfigurationMailingOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports